import Full from 'src/containers/Full'

function load(component) {
  return () => import(`src/${component}.vue`)
}

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      menuItem: false,
      permission: 'public',
      isForceInclude: true,
    },
  },
  {
    path: '/initializing',
    component: load('pages/initialize'),
    name: 'initialize',
    meta: {
      menuItem: false,
      permission: 'public',
      isForceInclude: true,
    },
  },
  {
    path: '/deny',
    component: Full,
    name: 'deny',
    redirect: '/deny/403',
    meta: {
      menuItem: false,
      permission: 'public',
      isForceInclude: true,
    },
    children: [
      {
        path: '403',
        component: load('pages/deny'),
        name: 'deny inline',
        meta: {
          menuItem: false,
          permission: 'public',
          isForceInclude: true,
        },
      },
    ],
  },
  {
    path: '/error',
    component: load('pages/error'),
    name: 'error',
    meta: {
      menuItem: false,
      permission: 'public',
      isForceInclude: true,
    },
  },
  {
    path: '/developer',
    component: load('containers/Standalone'),
    name: 'Developer Setup',
    redirect: '/developer/config',
    meta: {
      title: '@developer.title',
      menuItem: false,
      permission: 'public',
      isForceInclude: true,
    },
    children: [
      {
        path: 'config',
        component: load('application/global/components/developer/Config'),
        name: 'Developer Config Setup',
        meta: {
          menuItem: false,
          permission: 'public',
          isForceInclude: true,
        },
      },
    ],
  },
  {
    path: '*',
    component: load('pages/notFound'),
    name: '404',
    meta: {
      menuItem: false,
      permission: 'public',
      isForceInclude: true,
    },
  },
]
